<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <template>
              <b-row>
                <b-col sm="4">
                  <b-form-group label-for="driver" label="Driver">
                    <model-select
                      id="driver"
                      :options="listDriverEmployee"
                      v-model="driver"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div v-if="driver === null" class="invalid-feedback-custom">Driver harus di isi.</div>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group label-for="date" label="Tanggal Order">
                    <v-date-picker
                      mode="range"
                      id="date"
                      :input-props="{ class: 'form-control', placeholder: 'Tanggal Order', required: '', readonly: ''}"
                      v-model="myDate"
                    ></v-date-picker>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <div class="card">
      <div class="card-header">Export data Order</div>
      <div v-if="loading == true">
        <loading></loading>
      </div>
      <div class="card-body" v-if="loading == false">
        <div class="col-lg-3">
          <b-button type="button" size="sm" variant="primary" @click="downloadfile">
            <i class="fa fa-save"></i> Download
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import loading from "@/templates/Loading.vue";
import { ModelSelect } from "vue-search-select";
import * as moment from "moment";

export default {
  name: "box-in-car",
  components: {
    loading,
    ModelSelect
  },
  data() {
    return {
      loading: false,
      listDriverEmployee: [],
      myDate: null,
      driver: null
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.getDropdown();
    },
    downloadfile: function() {
      if (confirm("Are You Sure?")) {
        //this.loading = true;
        if (this.myDate === null) {
          alert("Tanggal Harus di pilih");
        } else {
          let start = moment(this.myDate.start).format("YYYY-MM-DD");
          let end = moment(this.myDate.end).format("YYYY-MM-DD");
          this.loading = true;
          this.axios({
            url:
              "web/export/data-box-in-car-basedon-driver/" +
              start +
              "/" +
              end +
              "/" +
              this.driver +
              "/" ,
            method: "GET",
            responseType: "arraybuffer" //before "blob"
          })
            .then(response => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "total_order.xlsx");
              document.body.appendChild(link);
              link.click();
            })
            .catch(error => {
              if (error.response.status === 401) {
                this.expired(error, "");
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
    getDropdown: function() {
      this.axios
        .get("web/dropdown/dropdown-spkb/")
        .then(response => {
          this.listDriverEmployee = response.data.driver;
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.expired(error, "");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>
